import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const Aside = styled(Box)(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    background-color: ${theme.palette.background.paper};
    width: 100%;
   
    border-radius: 15px;
    ${theme.breakpoints.up('sm')} {
      max-width: 480px;
    }}
`,
);

export const StepContainer = styled(Box)(
  ({ theme }) => `
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`,
);

export const Section = styled(Box)(
  ({ theme }) => `
    flex: 1;
    position: relative;
    height: 100%;
    margin-left: 30px;
`,
);

export const StyledRoot = styled(Box)`
  display: flex;
  flex-direction: column;

  & > section {
    flex: 1;
    position: relative;
  }
`;

export const VideoWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey['200'],
  minHeight: 280,
  maxWidth: 720,
  borderRadius: theme.shape.borderRadius,
  margin: 'auto',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));
